import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { ExperienceSchedulingService } from '../experience-scheduling.service';
import { ExperienceSchedulingAcceleratorCourseAssignmentsViewPart } from './accelerator-course-assignments/accelerator-course-assignments-view.part';
import { ExperienceSchedulingCurriculumSchedulesViewPart } from './curriculum-schedules/curriculum-schedules-view.part';
@Component({
	selector: 'experience-scheduling-views-part',
	standalone: true,
	imports: [
		ExperienceSchedulingCurriculumSchedulesViewPart,
		ExperienceSchedulingAcceleratorCourseAssignmentsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './experience-scheduling-views.part.html',
})
export class ExperienceSchedulingViewsPart implements OnInit {
	public service = inject(ExperienceSchedulingService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}